var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsReddit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C16.9706 22 21 19.0899 21 15.5C21 11.9101 16.9706 9 12 9C7.02944 9 3 11.9101 3 15.5C3 19.0899 7.02944 22 12 22Z",
    stroke: "#813EFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.78C14.503 17.5673 13.2704 17.9969 12 18C10.7296 17.9969 9.49705 17.5673 8.5 16.78",
    stroke: "#813EFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6C20.1046 6 21 5.10457 21 4C21 2.89543 20.1046 2 19 2C17.8954 2 17 2.89543 17 4C17 5.10457 17.8954 6 19 6Z",
    stroke: "#813EFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.07C18.1884 9.74369 18.4596 9.47291 18.7862 9.28503C19.1128 9.09714 19.4832 8.99882 19.86 9C21.042 9 22 9.95 22 11.12C22 11.937 21.534 12.646 20.85 13M6 10.07C5.81161 9.74369 5.5404 9.47291 5.2138 9.28503C4.8872 9.09714 4.51678 8.99882 4.14 9C3.86028 8.99868 3.58305 9.05248 3.32412 9.1583C3.06519 9.26413 2.82964 9.41992 2.63093 9.61679C2.43221 9.81365 2.27421 10.0477 2.16596 10.3056C2.0577 10.5636 2.00131 10.8403 2 11.12C2 11.937 2.466 12.646 3.15 13M17 4C14.643 4 13.464 4 12.732 4.732C12 5.464 12 6.643 12 9M9.008 13H8.999M15.008 13H14.999",
    stroke: "#813EFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsReddit);
export default __webpack_public_path__ + "static/media/hugeicons_reddit.9400e12a072d743f619f9b6161a1b2d5.svg";
export { ForwardRef as ReactComponent };